import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { map } from 'rxjs/operators';
import { PermissionModel } from '../models';
import * as _ from 'lodash';
import { ApiMode } from '../../utils/enums';
import { OfflineApiService } from './offlineApi.service';
import { AppConstants } from '../../utils/appConstants.class';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  constructor(private offlineApi: OfflineApiService) {}

  private permissions: any[];

  public getPermissionsList(): Observable<any> {
    if (this.permissions) {
      return new BehaviorSubject(this.permissions).asObservable();
    } else {
      return this.offlineApi
        .getWithMode('/permissions', ApiMode.Offline, AppConstants.INDEXEDDB_TABLES.permissions)
        .pipe(
          map((permissions) => {
            this.permissions = [];
            permissions.forEach((el) => this.permissions.push(new PermissionModel(el.Label, el.Value)));
            return this.permissions;
          })
        );
    }
  }

  getValue(value: any, array: any): string {
    const obj = _.find(array, ['value', value]);
    return obj ? obj.label : '';
  }
}
